export default __webpack_public_path__ + "static/media/MET.243ea51c.png";